import script from "./resource.vue?vue&type=script&setup=true&lang=js"
export * from "./resource.vue?vue&type=script&setup=true&lang=js"

import "./resource.vue?vue&type=style&index=0&id=b1e62f54&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1e62f54"]])

export default __exports__